<template>
	<div class="app-container userIndex">
		<el-card>
			<div slot="header" class="clearfix">
				<h3 class="pageName">{{pageName}}</h3>
			</div>
			<el-form :model="queryParams" ref="queryForm" :inline="true" size="small" class="box_form">
				<el-form-item label="" prop="keyWord">
					<el-input v-model="queryParams.keyWord" placeholder="用户手机号/昵称" clearable
						@keyup.enter.native="handleQuery" @change="$forceUpdate()"></el-input>
				</el-form-item>
				<el-form-item label="" prop="memberType">
					<el-select v-model="queryParams.memberType" placeholder="用户类型" clearable filterable
						@change="$forceUpdate()">
						<el-option v-for="(item, index) in userType" :key="index" :label="item.name"
							:value="item.value" />
					</el-select>
				</el-form-item>
				<el-form-item label="" prop="userStatus">
					<el-select filterable v-model="queryParams.userStatus" placeholder="用户状态" clearable
						@change="$forceUpdate()">
						<el-option v-for="(item, index) in userStatus" :key="index" :label="item.name"
							:value="item.value" />
					</el-select>
				</el-form-item>
				<el-form-item label="" prop="time">
					<el-date-picker v-model="queryParams.time" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
						:default-time="['00:00:00', '23:59:59']" range-separator="-" start-placeholder="注册时间"
						end-placeholder="注册时间" @change="$forceUpdate()"></el-date-picker>
				</el-form-item>
				<el-form-item label="" prop="sourceMemberMobile">
					<el-input v-model="queryParams.sourceMemberMobile" placeholder="邀请人" style="width: 160px"
						@keyup.enter.native="handleQuery" @change="$forceUpdate()" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
					<el-button icon="el-icon-refresh-left" @click="resetQuery">重置</el-button>
					<el-button icon="el-icon-download" @click="handleExport">导出数据</el-button>
				</el-form-item>
			</el-form>

			<el-table v-loading="loading" element-loading-text="加载中" :data="list">
				<el-table-column label="序号" align="center" type="index" width="50" />
				<el-table-column label="用户账号" align="center" prop="mobile" />
				<el-table-column label="用户昵称" align="center" prop="nickName" />
				<el-table-column label="用户类型" align="center" prop="memberType">
					<template slot-scope="scope">
						<span v-if="scope.row.memberType == 'app_user'">普通用户</span>
						<span v-if="scope.row.memberType == 'agent'">主理人</span>
					</template>
				</el-table-column>
				<el-table-column label="用户状态" align="center" prop="userStatus">
					<template slot-scope="scope">
						<span>{{ scope.row.userStatus == '0' ? '正常' : '禁用' }}</span>
					</template>
				</el-table-column>
				<el-table-column label="邀请人" align="center" prop="sourceMemberMobile" />
				<el-table-column label="订单记录" align="center" prop="orderNum">
					<template slot-scope="scope">
						<span>{{ scope.row.orderNum || 0 }}</span>
					</template>
				</el-table-column>
				<el-table-column label="积分余额" align="center" prop="usableBalance" sortable></el-table-column>
				<el-table-column label="注册时间" align="center" prop="createTime"></el-table-column>
				<el-table-column label="操作" align="center" class-name="small-padding fixed-width">
					<template slot-scope="scope">
						<el-button size="small" plain type="primary" @click="handleDtl(scope.row)">详情</el-button>
						<el-button size="small" plain type="primary" @click="handleEdit(scope.row)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>

			<pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="_getList" />

			<el-dialog title="设置" :visible.sync="dialogShow" width="600px" append-to-body>
				<el-form ref="setform" :model="setParams" size="mini" :rules="rules" label-width="120px">
					<el-form-item label="是否主理人:" prop="memberType">
						<el-radio-group v-model="setParams.memberType">
							<el-radio label="agent">是</el-radio>
							<el-radio label="app_user">不是</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="用户状态:" prop="userStatus">
						<el-radio-group v-model="setParams.userStatus">
							<el-radio label="0">正常</el-radio>
							<el-radio label="1">禁用</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="备注内容:" prop="remark">
						<el-input :rows="5" type="textarea" maxlength="300" placeholder="输入备注" show-word-limit
							v-model="setParams.remark" />
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="submitForm">确 定</el-button>
					<el-button @click="dialogShow = false">取 消</el-button>
				</div>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
	import * as API_User from "@/api/sportManage/user";

	export default {
		name: "userIndex",
		data() {
			return {
				pageName: '用户列表',
				userStatus: [{
						value: '0',
						name: "正常",
					},
					{
						value: '1',
						name: "禁用",
					},
				],
				userType: [{
						value: 'agent',
						name: "主理人",
					},
					{
						value: 'app_user',
						name: "普通用户",
					},
				],
				queryParams: {
					keyWord: '',
					memberType: '',
					userStatus: '',
					pageNum: 1,
					pageSize: 10,
					sourceMemberMobile: '',
					time: [],
				},
				list: [],
				total: 0,
				loading: false,

				dialogShow: false,
				setParams: {
					userStatus: '0',
					memberType: 'app_user',
					remark: ''
				},
				rules: {
					userStatus: [{
						required: true,
						message: "请选择用户状态",
						trigger: "change"
					}],
					memberType: [{
						required: true,
						message: "是否组里人",
						trigger: "change"
					}, ],
					remark: [{
						required: true,
						message: "请输入备注内容",
						trigger: "blur"
					}, ]
				},
			};
		},
		created() {
			this._getList()
		},
		methods: {
			handleQuery() {
				this.queryParams.startTime = this.queryParams.time ? this.queryParams.time[0] : "";
				this.queryParams.endTime = this.queryParams.time ? this.queryParams.time[1] : "";
				this.queryParams.pageNum = 1;
				this._getList();
			},
			resetQuery() {
				this.$refs["queryForm"].resetFields();
				this.queryParams.startTime = ''
				this.queryParams.endTime = ''
				this._getList();
			},
			refreshList() {
				this.resetQuery();
				this.dialogShow = false
			},
			handleExport() {
				this.download(
					"/biz/member/export", {
						...this.queryParams,
					},
					`用户列表` + new Date().getTime() + `.xlsx`
				);
			},
			// 接口-用户列表
			_getList() {
				API_User.userList(this.queryParams).then((res) => {
					this.total = res.data.total;
					this.list = res.data.list;
				}).catch((err) => {

				});
			},
			_editUser() {
				API_User.editUser(this.setParams).then((res) => {
					console.log(res);
					this.$message({
						message: '编辑成功',
						type: 'success'
					})
					this.refreshList()
				}).catch((err) => {

				});
			},
			// 编辑用户
			handleEdit(row) {
				console.log(row);
				this.dialogShow = true
				this.setParams = JSON.parse(JSON.stringify(row));
			},
			// 用户详情
			handleDtl(row) {
				console.log(row);
				this.$router.push({
					path: '/user/detail',
					query: {
						id: row.id,
					},
				})
			},
			submitForm() {
				this.$refs['setform'].validate((valid) => {
					if (valid) {
						this._editUser()
					} else {
						console.log('error submit!!');
						this.$message({
							message: '填写数据不全或数据有误',
							type: 'error'
						});
						return false;
					}
				});
			}
		},
	};
</script>

<style lang="scss">
	@import "../../../assets/styles/common.scss";

	.userIndex {
		padding: 40px 40px;
		color: #676a6c;
		font-size: 13px;
		font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
		overflow-x: hidden;

	}
</style>